import { styled } from '@flex-design-system/stitches-react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Primitive } from '@radix-ui/react-primitive';
import { ScrollArea } from '../scroll-area/ScrollArea.mjs';

const PADDING_X = 40;
const calcMaxHeight = (offset = 0) => `calc(100vh - 56px + ${typeof offset === "string" ? offset : `${offset}px`})`;
const parseStyleValue = (value) => typeof value === "string" ? value : `${value}px`;
function getAdjustModalHeight(height, options) {
  const offsetHeight = options?.offset ?? 0;
  return `min(${parseStyleValue(height)}, ${calcMaxHeight(
    parseStyleValue(offsetHeight)
  )})`;
}
const StyledContent = styled(DialogPrimitive.Content);
const StyledToolbar = styled(Primitive.div);
const StyledTitle = styled(DialogPrimitive.Title);
const StyledScrollAreaViewport = styled(ScrollArea.Viewport_Legacy);
const StyledScrollAreaChildrenRoot = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "100%"
});
const StyledFooter = styled("footer");
const StyledPortalContainer = styled(Primitive.div);

export { PADDING_X, StyledContent, StyledFooter, StyledPortalContainer, StyledScrollAreaChildrenRoot, StyledScrollAreaViewport, StyledTitle, StyledToolbar, getAdjustModalHeight };
//# sourceMappingURL=styled.mjs.map
